import React, { useState } from "react";

import GameContent from "./GameContent";
import GameMenu from "./GameMenu";

const View = (props) => {
  const [fullscreen, setFullscreen] = useState(false);
  const toggleFullscreen = () => setFullscreen(!fullscreen);

  return (
    <div id="innerMenuContainer" className="overlay overlay--game">
      <GameMenu
        {...props}
        toggleFullscreen={toggleFullscreen}
        fullscreen={fullscreen}
      />
      <GameContent
        {...props}
        toggleFullscreen={toggleFullscreen}
        fullscreen={fullscreen}
      />
    </div>
  );
};

export default View;
